module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/insider-activity/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["insideractivity"]) {
      return resolve(window.remoteLoading["insideractivity"])
    }

    var res, rej;
    window.remoteLoading["insideractivity"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["insideractivity"] !== 'undefined') {
      res(window["insideractivity"]);
      return resolve(window["insideractivity"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["insideractivity"] !== 'undefined') {
          res(window["insideractivity"]);
          return resolve(window["insideractivity"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "insideractivity"
    );
  }).then(function () {
    const proxy = {
      get: insideractivity.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          insideractivity.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        insideractivity.__initialized = true
      }
    }
    if (!insideractivity.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });